import ValidateUserAndPresentLogon from "features/Header/PuzzelTelephone/components/ValidateUserAndPresentLogon";
import { PuzzelAuthenticationProvider } from "features/Header/PuzzelTelephone/provider/contexts/PuzzelAuthenticationContext";
import { UserValidationProvider } from "features/Header/PuzzelTelephone/provider/contexts/UserValidationContext";
import { ReactElement, ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export const PuzzelProvider = ({ children }: Props): ReactElement | null => (
  <PuzzelAuthenticationProvider>
    <UserValidationProvider>
      <ValidateUserAndPresentLogon>{children}</ValidateUserAndPresentLogon>
    </UserValidationProvider>
  </PuzzelAuthenticationProvider>
);
